import { useLingui } from '@lingui/react';
import { CarleadCreationButton, CarleadCreationForm, CarleadMileageFormatted, defaultCarleadCreationLPFlow, Email, QuestionnaireSelect, renderFieldVerticalWrapper, useCreateCarleadChainedRequest, useCreateConsumerCarleadWithLicensePlateRequestChain, useFormQuestionnaireProps, useNormalFlowService, useStep2LPCarleadForm } from '@wkda/carlead-creation-components';
import cx from 'classnames';
import { useTrackLanding } from '@wkda/funnel-components';
import { Paper } from '@wkda/styleguide';
import { CarleadProgress, TrustPilot, ReturningCustomerPopup } from '../../../../../../components';
import { CheckSuspiciousMileageMethod } from '@wkda/funnel-utils';
import { i18n as _i18n } from "@lingui/core";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
const CarleadLicensePlateDefaultStep2 = ({
  wide = false,
  headlineDesktop = 'carleadCreation.form.mainTitle',
  headlineMobile = 'carleadCreation.form.mainTitle.mobile',
  className = '',
  subheadline = false
}) => {
  const questionnaireProps = useFormQuestionnaireProps(defaultCarleadCreationLPFlow);
  const machine = useNormalFlowService(defaultCarleadCreationLPFlow);
  const request = useCreateCarleadChainedRequest([
  // make this the last one
  useCreateConsumerCarleadWithLicensePlateRequestChain()]);
  const consumerForm = useStep2LPCarleadForm([questionnaireProps]);
  const {
    i18n
  } = useLingui();
  useTrackLanding();
  return /*#__PURE__*/_jsxs(Paper, {
    className: "carlead-creation-form__container license-plate step-2",
    children: [/*#__PURE__*/_jsx(ReturningCustomerPopup, {}), /*#__PURE__*/_jsx("div", {
      className: `box gap full-height ${className}`,
      children: /*#__PURE__*/_jsxs("div", {
        className: cx('container', {
          'container-xl': wide
        }),
        children: [/*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx("h1", {
            className: "carlead-creation-form__title d-none d-md-block",
            dangerouslySetInnerHTML: {
              __html: i18n._(headlineDesktop)
            }
          }), /*#__PURE__*/_jsx("h1", {
            className: "carlead-creation-form__title d-block d-md-none",
            dangerouslySetInnerHTML: {
              __html: i18n._(headlineMobile)
            }
          })]
        }), subheadline && /*#__PURE__*/_jsx("p", {
          className: "carlead-creation-form__subheadline",
          children: i18n._(subheadline)
        }), /*#__PURE__*/_jsxs(CarleadCreationForm, {
          carleadForm: consumerForm,
          machineService: machine,
          submitHandler: request,
          children: [/*#__PURE__*/_jsx(CarleadMileageFormatted, {
            lowerThreshold: 2500,
            upperThreshold: 35000,
            suspiciousMileageMessageDelay: 2000,
            isHiddenField: true,
            renderFieldWrapper: renderFieldVerticalWrapper,
            suspiciousMileageCheckType: CheckSuspiciousMileageMethod.Normal
          }), /*#__PURE__*/_jsx(QuestionnaireSelect, {
            renderFieldWrapper: renderFieldVerticalWrapper,
            name: "SELLPOINT",
            label: _i18n._(
            /*i18n*/
            {
              id: 'carleadCreation.form.label.sellpoint'
            }),
            isHiddenField: true,
            answers: [{
              label: _i18n._(
              /*i18n*/
              {
                id: 'carleadCreation.option.sellpointNow'
              }),
              value: 'SELLPOINT_NOW'
            }, {
              label: _i18n._(
              /*i18n*/
              {
                id: 'carleadCreation.option.sellpoint4weeks'
              }),
              value: 'SELLPOINT_4_WEEKS'
            }, {
              label: _i18n._(
              /*i18n*/
              {
                id: 'carleadCreation.option.sellpoint3months'
              }),
              value: 'SELLPOINT_3_MONTHS'
            }, {
              label: _i18n._(
              /*i18n*/
              {
                id: 'carleadCreation.option.sellpointNotPlanned'
              }),
              value: 'SELLPOINT_NOT_PLANNED'
            }]
          }), /*#__PURE__*/_jsx(QuestionnaireSelect, {
            renderFieldWrapper: renderFieldVerticalWrapper,
            name: "SELL_TYPES",
            label: _i18n._(
            /*i18n*/
            {
              id: 'carleadCreation.form.label.sellTypes'
            }),
            isHiddenField: true,
            answers: [{
              label: _i18n._(
              /*i18n*/
              {
                id: 'carleadCreation.option.sellTypesPrivate'
              }),
              value: 'PRIVATE'
            }, {
              label: _i18n._(
              /*i18n*/
              {
                id: 'carleadCreation.option.sellTypesDealer'
              }),
              value: 'DEALER'
            }]
          }), /*#__PURE__*/_jsx(Email, {
            isHiddenField: true,
            renderFieldWrapper: renderFieldVerticalWrapper
          }), /*#__PURE__*/_jsx(CarleadProgress, {}), /*#__PURE__*/_jsx(CarleadCreationButton, {})]
        }), /*#__PURE__*/_jsxs("section", {
          className: "trust-box",
          children: [/*#__PURE__*/_jsx("div", {
            className: "d-none d-md-block",
            children: /*#__PURE__*/_jsx(TrustPilot, {
              type: "lead",
              screen: "desktop"
            })
          }), /*#__PURE__*/_jsx("div", {
            className: "d-block d-md-none",
            children: /*#__PURE__*/_jsx(TrustPilot, {
              type: "lead",
              screen: "mobile"
            })
          })]
        })]
      })
    })]
  });
};
export default CarleadLicensePlateDefaultStep2;